import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';

@Component({
  selector: 'app-package-basic-info',
  templateUrl: './package-basic-info.component.html',
  styleUrls: ['./package-basic-info.component.css']
})
export class PackageBasicInfoComponent implements OnInit {

  @Input() packageForm: DVFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
